var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { QuestionAnswerState } from '../../../classes/learnware/LearnwareEnums';
import { runtime } from '../../../classes/runtime/Runtime';
let CycleBarCenteredImmediateButton = class CycleBarCenteredImmediateButton extends React.PureComponent {
    get top() {
        let top = runtime.solidBrowserRuntime.browserWindow.windowHeightInPixel - 190;
        if (this.props.app.menubarRight.isMultiPlayerMode)
            top -= 120;
        return top;
    }
    render() {
        const { app } = this.props;
        if (app.appInfo.isMobileAppWebView) {
            return null;
        }
        if (!app.question) {
            return null;
        }
        if (app.question.answeringState.currentAnswerState !== QuestionAnswerState.Feedback) {
            return null;
        }
        return (React.createElement("div", { className: "CycleBarCenteredImmediateButton", style: {
                top: this.top,
                left: runtime.solidBrowserRuntime.browserWindow.windowWidthInPixel / 2 - 100,
                zIndex: 2,
            }, onClick: app.cycle.cycleNavigate.handleNextClick }, "Sofort weiter"));
    }
};
CycleBarCenteredImmediateButton = __decorate([
    observer
], CycleBarCenteredImmediateButton);
export { CycleBarCenteredImmediateButton };
